import styled, { css } from 'styled-components';
export const Container = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;

  ${({ $size }) => $size === 'small' &&
    css `
      width: 32px;
      height: 32px;
    `}

  ${({ $size }) => $size === 'medium' &&
    css `
      width: 40px;
      height: 40px;
    `}

  ${({ $size }) => $size === 'regular' &&
    css `
      width: 48px;
      height: 48px;
    `}

  ${({ $hoverable }) => $hoverable &&
    css `
      cursor: pointer;

      &:hover {
        outline: 3px solid var(--border-secondary);
      }
    `}

  ${({ $active }) => $active &&
    css `
      &,
      &:hover {
        outline: 3px solid var(--border-active);
      }
    `}
`;
export const EmptyContainer = styled(Container) `
  border: 1px dashed var(--border-primary);
  font-weight: var(--font-weight-semibold);
  font-size: var(--font-size-300);
  line-height: var(--font-line-height-300);
  color: var(--text-secondary);
`;
export const Image = styled.img `
  border-radius: inherit;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
export const Initials = styled.div `
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary-invert);

  ${({ $size }) => $size === 'small' &&
    css `
      font-size: var(--font-size-100);
    `}

  ${({ $size }) => $size === 'medium' &&
    css `
      font-size: var(--font-size-300);
    `}

  ${({ $size }) => $size === 'regular' &&
    css `
      font-size: var(--font-size-300);
    `}
`;
